import vdh from "../../../../assets/images/productos/vdh/VDH arg.png";
import qr from "../../../../assets/images/QR Fabian Llamazares.svg";
import Producto from "../../../../components/producto";
import pic1 from "../../../../assets/images/productos/vdhgsmi/Mosaico - GSMI1.png";
import pic2 from "../../../../assets/images/productos/vdhgsmi/Mosaico - GSMI2.png";

import { useTranslation } from "react-i18next";

function VDH() {

  const {t} = useTranslation();
  
  return (
    <Producto
      fotos={[pic1, pic2]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "38"],
        [t("corrienteNominal"), "A", "1.200 / 2.000 / 3.000"],
        [t("corrienteInterrupcionNominal"), "kA", "25 / 31,5 / 40"],
        [t("tensionDeImpulso"), "kV", "200"],
        [t("capacidadDeCierreNominal"), "kA", "65 / 82 / 104"],
        [t("tensionSoportada"), "kV", "80"],
        [t("frecuenciaNominal"), "Hz", "50/60"],
        [t("tiempoDeCierreNominal"), "msec", "< 55"],
        [t("tiempoDeAperturaNominal"), "msec", "< 30"],
        [t("tiempoDeArcoNominal"), "msec", "4/11"],
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "1.800"],
        [t("alto"), "mm", "3.255 / 3.755"],
        [t("profundidad"), "mm", "1.800"],
      ]}
      nombreProducto={"VDH"}
      fotoProducto={vdh}
      descripcionProducto={
        t("vdh.titulo_descripcion")
      }
      caracteristicas={[
        t("vdh.bullet1"),
        t("vdh.bullet2"),
        t("vdh.bullet3"),
        t("vdh.bullet4")
      ]}
      vendedor={{
        nombre: "Fabian Llamazares",
        telefono: "+54 9 11 5096-3680",
        mail: "fllamazares@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20VDH%2038%20USA.pdf'}
    />
  );
}

export default VDH;